import React from 'react'

const CONTENT_SQUARE_MASK = 'data-cs-mask'

export function maskElement(el) {
  el.setAttribute(CONTENT_SQUARE_MASK, true)
}

/**
 * This is a Higher-Order Component that marks its child as having sensitive content.
 * Adds a the `[data-cs-mask]` attribute to its child to prevent the content from
 * being sent to ContentSquare.
 *
 * @See https://docs.contentsquare.com/uxa-en/#recorded-html-for-session-replay
 */
export default ({ children }) => {
  // TODO: once on React 16, use <React.Fragment> to wrap any number of children
  // instead of React.Children.only to ensure a single child
  const child = React.Children.only(children)

  return React.cloneElement(child, {
    [CONTENT_SQUARE_MASK]: true,
  })
}
